// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import './assets/css/main.css'
import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import htmlToPdf from './components/utils/htmlToPdf'
import store from './store'
import './config/axios'
import keep from './store/modules/keep'

// 引入htmlToPdf插件
Vue.use(htmlToPdf)

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.prototype.axios = axios

Vue.use(VueAwesomeSwiper)

// 路由跳转之前
router.beforeEach((to, from, next) => {
  let isLogin = sessionStorage.getItem('isLogin')
  // 注销
  if (to.path === '/logout') {
    // 清空
    sessionStorage.clear()
    // 跳转到登录页面
    next({path: '/login'})
  } else if (to.path === '/login') {
    // 判断是否为空，不为空跳转到首页
    if (isLogin != null) {
      next({path: '/'})
    }
  } else if (isLogin == null) {
    next({path: '/login'})
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  render: h => h(App),
  router,
  store,
  keep
})



// WEBPACK FOOTER //
// ./src/main.js